export const markdownRemover = (text) => {
    return text.replace(/[^a-zA-Z0-9$!,.?\s]/g, '');
}
